<template>
  <div :class="[fullWidth && '!w-full']" class="flex flex-col gap-y-1">
    <Field name="recaptchaResponse" v-slot="{ handleChange, errors }" :rules="buildRule">
      <GRecaptcha
        :key="recatpchaResetKey"
        ref="gRecaptchaRef"
        class="flex justify-center"
        @successCallback="(args) => handleChange(args)"
      ></GRecaptcha>
      <div :class="[fullWidth && '!w-full']" class="flex flex-col gap-y-1 text-xs ltr:font-sans">
        <span :key="err" v-for="err in errors" class="text-brand-red">
          {{ $t(err) }}
        </span>
      </div>
    </Field>
  </div>
</template>

<script setup>
import { Field } from 'vee-validate'
import GRecaptcha from '@/components/GRecaptcha/index.vue'
import useRuleHandler from '@/composables/useRuleHandler'

const props = defineProps({
  fullWidth: {
    type: Boolean,
    default: false
  },
  rules: Array
})

const buildRule = async (value) => {
  return await useRuleHandler(value, props.rules)
}
</script>

<style lang="scss" scoped></style>
